export const recordResultTypes = Object.freeze([
  { value: 1, label: '审核中', color: 'rgba(54, 56, 59, 1)' },
  { value: 2, label: '未备案', color: 'rgba(255, 177, 0, 1)' },
  { value: 3, label: '备案成功', color: 'rgba(103, 194, 58, 1)' },
  { value: 4, label: '备案失败', color: 'rgba(245, 108, 108, 1)' },
]);

/*
* 机械备案状态
* */
export const machineRecordResultTypes = Object.freeze([
  { value: 2, label: '未备案', color: 'rgba(255, 177, 0, 1)' },
  { value: 3, label: '备案成功', color: 'rgba(103, 194, 58, 1)' },
  { value: 4, label: '备案失败', color: 'rgba(245, 108, 108, 1)' },
  { value: 5, label: '删除备案中', color: 'rgba(255, 177, 0, 1)' },
  { value: 6, label: '删除备案成功', color: 'rgba(103, 194, 58, 1)' },
  { value: 7, label: '删除备案失败', color: 'rgba(245, 108, 108, 1)' },
]);

/*
* 查询平台名称
* */
export const searchPlatformName = Object.freeze([
  {label: '国家平台', value: 0},
  {label: '国家平台-重型柴油车', value: 1},
  {label: '国家平台-重型燃气车', value: 2},
  {label: '国家平台-油电混合', value: 3},
  {label: '国家平台-气电混合', value: 4},
  {label: '国家平台-双燃料汽车', value: 5}
]);

/*
* 平台名称
* */
export const platformName = Object.freeze([
  // { label: '国家平台', value: 0 },
  {label: '国家平台-重型柴油车', value: 1},
  {label: '国家平台-重型燃气车', value: 2},
  {label: '国家平台-油电混合', value: 3},
  {label: '国家平台-气电混合', value: 4},
  {label: '国家平台-双燃料汽车', value: 5}
]);

/*
* 激活模式
* */
export const isActivateTypes = Object.freeze([
  {label: '无需激活', value: 0},
  {label: '需要激活', value: 1}
]);

/*
* 燃料类型
* */
export const fuelTypes = Object.freeze([
  // { label: '轻型汽油车', value: 0 },
  // { label: '轻型柴油车', value: 1 },
  // { label: '轻型燃气车', value: 2 },
  // { label: '轻型两用燃料车', value: 3 },
  {label: '重型柴油车', value: 4},
  {label: '重型燃气车', value: 5},
  {label: '双燃料汽车', value: 20},
  {label: '油电混合汽车', value: 21},
  {label: '气电混合汽车', value: 22}
  // { label: '重型两用燃料车', value: 6 },
  // { label: '轻型汽油混合动力车', value: 10 },
  // { label: '轻型柴油混合动力车', value: 11 },
  // { label: '轻型燃气混合动力车', value: 12 },
  // { label: '轻型两用燃料混合动力车', value: 13 },
  // { label: '重型柴油混合动力车', value: 14 },
  // { label: '重型燃气混合动力车', value: 15 },
  // { label: '重型两用燃料混合动力车', value: 16 }
]);

/*
* 机械类型
* */
export const terminalReplaceMachineTypes = Object.freeze([
  {label: '工程机械', value: 0},
  {label: '农业机械', value: 1},
  {label: '机场地勤设备', value: 2},
  {label: '材料装卸机械', value: 3},
  {label: '雪犁装备', value: 4},
  {label: '工业钻探设备', value: 5}
])

/*
* 备案平台
* */
export const recordPlatforms = Object.freeze([
  {label: '非道路机械国家平台', value: 1}
])

/*
* 账号类型
* */
export const machineryTypeConfig = Object.freeze({
  0: "工程机械",
  1: "非工程机械"
});

/*
 * 平台名称
 * */
export const platformTypes = Object.freeze([
  {label: '非道路机械国家平台', value: 1},
]);

/*
* 联网状态
* */
export const connectedStatusConfig = Object.freeze({
  0: '未联网',
  1: '已联网'
});

/*
* 指令发送状态
* */
export const commandSendStatusConfig = Object.freeze({
  0: '未发送',
  1: '发送成功',
  2: '发送失败',
  3: '下发中'
});

/*
* 激活模式
* */
export const isActivateConfig = Object.freeze({
  0: '无需激活',
  1: '需要激活'
});

/*
* 车辆状态
* */
export const onlineStatusConfig = Object.freeze({
  1: '在线',
  0: '离线'
});